(() => {
  if (window.__abrsmBlogPosts) {
    window.__abrsmBlogPosts.initAll();
    return;
  }

  const selector = '.abrsm-blog-posts';
  const collectRoots = (scope = document) => {
    const roots = [];
    if (scope.matches?.(selector)) roots.push(scope);
    scope.querySelectorAll?.(selector).forEach((root) => roots.push(root));
    return roots;
  };

  const initBlogPosts = (root) => {
    const list = root.querySelector('[data-local-posts]');
    if (!list || list.dataset.rendered === '1') return;
    list.dataset.rendered = '1';
    root.dataset.abrsmBlogInitialized = 'true';
    const emptyState = root.querySelector('[data-empty-state]');
    const sectionId = root.dataset.sectionId || 'blog';
    const lifecycleController = new AbortController();
    const activeFetchControllers = new Set();
    const idleIds = new Set();
    const timeoutIds = new Set();
    let startObserver = null;
    let destroyed = false;

    root.abrsmBlogCleanup = () => {
      destroyed = true;
      lifecycleController.abort();
      startObserver?.disconnect();
      activeFetchControllers.forEach((controller) => controller.abort());
      idleIds.forEach((id) => window.cancelIdleCallback?.(id));
      timeoutIds.forEach((id) => window.clearTimeout(id));
      delete list.dataset.rendered;
      delete root.dataset.abrsmBlogInitialized;
      delete root.abrsmBlogCleanup;
    };

      function setState(s){ list.setAttribute('data-remote-state', s); }
      function toggleEmptyState(show){
        if(!emptyState) return;
        emptyState.hidden = !show;
      }
      function scheduleWork(task){
        if(window.requestIdleCallback){
          const id = window.requestIdleCallback(function(){
            idleIds.delete(id);
            if(!destroyed) task();
          }, { timeout: Math.max(1200, cfg.timeout) });
          idleIds.add(id);
          return;
        }
        const id = window.setTimeout(function(){
          timeoutIds.delete(id);
          if(!destroyed) task();
        }, 1);
        timeoutIds.add(id);
      }

      const sanitizeSentinel = (v) => {
        const s = (v || '').trim();
        if (s === '/' || s === '-' || s.toLowerCase() === 'none') return '';
        return s;
      };

      const cfg = {
        enable: list.getAttribute('data-remote-enable') === 'true',
        feedUrl: sanitizeSentinel(list.getAttribute('data-remote-url') || ''),
        jsonEndpoint: sanitizeSentinel(list.getAttribute('data-remote-json-endpoint') || ''),
        seed: sanitizeSentinel(list.getAttribute('data-remote-seed') || ''),
        limit: parseInt(list.getAttribute('data-remote-limit') || '3', 10),
        insert: (list.getAttribute('data-remote-insert') || 'before').trim(),
        open: (list.getAttribute('data-remote-open') || 'new').trim(),
        nofollow: list.getAttribute('data-remote-nofollow') === 'true',
        proxy: (list.getAttribute('data-remote-proxy') || 'auto').trim(),
        allowPublicProxies: list.getAttribute('data-remote-public-proxies') === 'true',
        lazy: list.getAttribute('data-remote-lazy') === 'true',
        timeout: parseInt(list.getAttribute('data-remote-timeout') || '3500', 10),
        cacheMins: parseInt(list.getAttribute('data-remote-cache-mins') || '1440', 10),
        hideLocalDupes: list.getAttribute('data-remote-hide-local-dupes') === 'true',
        sizes: (list.getAttribute('data-sizes') || '').trim(),
        excerptWords: parseInt(list.dataset.excerptWords || '25', 10)
      };
      if(!cfg.enable) return;

      const DISABLE_CACHE = list.dataset.remoteDisableCache === 'true';
      const SEED_ONLY = list.dataset.remoteSeedOnly === 'true';

      const OPEN_TARGET = cfg.open === 'new' ? '_blank' : '_self';
      const REL_VALUE = cfg.nofollow ? 'nofollow noopener' : 'noopener';
      const DEFAULT_FEED = 'https://www.abrsm.org/en-gb/rss.xml';
      const CACHE_VERSION = 'v6';

      const SHOW_LABEL = list.dataset.showLabel === 'true';
      const SHOW_NEW = list.dataset.showNew === 'true';
      const SHOW_EXCERPT = list.dataset.showExcerpt === 'true';
      const NEW_DAYS = parseInt(list.dataset.newDays || '7', 10);
      const READ_MORE = list.dataset.readMore || 'Read more';
      const LABEL_TEXT = list.dataset.labelText || 'ABRSM';

      function normaliseUrl(u){
        try{
          const url = new URL(u);
          return (url.origin + url.pathname).replace(/\/+$/,'').toLowerCase();
        }catch(_e){
          return (u||'').trim().toLowerCase();
        }
      }
      const baseKey = normaliseUrl(cfg.feedUrl || DEFAULT_FEED);
      const kLS = 'abrsm_feed_cache_' + CACHE_VERSION + ':' + sectionId + ':' + baseKey;
      const kSS = kLS + ':session';

      function ensureHttps(u, base){
        if(!u) return '';
        const raw = String(u).trim();
        let candidate = raw;
        if(candidate.startsWith('//')){
          candidate = 'https:' + candidate;
        } else if(!/^[a-z][a-z0-9+.-]*:/i.test(candidate) && !candidate.startsWith('/')){
          candidate = 'https://' + candidate.replace(/^\/+/,'');
        }
        try{
          const url = new URL(candidate, base || DEFAULT_FEED);
          if(url.protocol !== 'http:' && url.protocol !== 'https:') return '';
          url.protocol = 'https:';
          return url.toString();
        }catch(_e){
          return '';
        }
      }
      function originOf(urlStr, fallback){
        try{ return new URL(urlStr).origin; }catch(_e){ return fallback || 'https://www.abrsm.org'; }
      }
      function resolveUrl(u, base){
        if(!u) return '';
        return ensureHttps(u, base || DEFAULT_FEED);
      }
      function decodeEntities(s){
        const d = document.createElement('div');
        d.innerHTML = s || '';
        return d.textContent || d.innerText || '';
      }
      function htmlToText(h){
        const d = document.createElement('div');
        d.innerHTML = h || '';
        return (d.textContent || d.innerText || '').replace(/\s+/g,' ').trim();
      }
      function truncateWords(t, n){
        if(!t) return '';
        const a = t.split(/\s+/);
        return a.length <= n ? t : a.slice(0,n).join(' ') + '…';
      }

      // Featured/hero image helper: prefer og:image/twitter:image, then fallbacks.
      function extractFirstImg(s){
        const src = s || '';

        let m =
          src.match(/<meta[^>]+property=["']og:image["'][^>]+content=["']([^"']+)["'][^>]*>/i) ||
          src.match(/<meta[^>]+name=["']og:image["'][^>]+content=["']([^"']+)["'][^>]*>/i) ||
          src.match(/<meta[^>]+name=["']twitter:image["'][^>]+content=["']([^"']+)["'][^>]*>/i);
        if (m && m[1]) return m[1];

        m = src.match(/<img[^>]+src\s*=\s*"([^"]+)"/i) ||
            src.match(/<img[^>]+src\s*=\s*'([^']+)'/i);
        if (m && m[1]) return m[1];

        m = src.match(/<img[^>]+srcset\s*=\s*"([^"]+)"/i) ||
            src.match(/<img[^>]+srcset\s*=\s*'([^']+)'/i);
        if (m && m[1]) {
          const first = (m[1].split(',')[0] || '').trim().split(/\s+/)[0];
          if (first) return first;
        }

        m = src.match(/<source[^>]+srcset\s*=\s*"([^"]+)"/i) ||
            src.match(/<source[^>]+srcset\s*=\s*'([^']+)'/i);
        if (m && m[1]) {
          const first = (m[1].split(',')[0] || '').trim().split(/\s+/)[0];
          if (first) return first;
        }

        m = src.match(/<media:content[^>]+url="([^"]+)"/i);
        if (m && m[1]) return m[1];

        m = src.match(/background-image:\s*url\((['"]?)(.*?)\1\)/i);
        if (m && m[2]) return m[2];

        return '';
      }

      function containsXmlSignature(s){
        return /<rss[\s>]/i.test(s) || /<feed[\s>]/i.test(s) || /<channel[\s>]/i.test(s) || /<item[\s>]/i.test(s);
      }
      function deDupe(items){
        const seen = new Set(); const out=[];
        for(const it of items){
          const key = normaliseUrl(it.link)+'|'+(it.title||'').trim().toLowerCase();
          if(seen.has(key)) continue;
          seen.add(key); out.push(it);
        }
        return out;
      }
      function saveCache(items){
        if (DISABLE_CACHE) return;
        try{
          const payload={ ts:Date.now(), items };
          localStorage.setItem(kLS, JSON.stringify(payload));
          sessionStorage.setItem(kSS, JSON.stringify(payload));
        }catch(_e){}
      }
      function getCache(allowStale){
        if (DISABLE_CACHE) return null;
        try{
          const ss = sessionStorage.getItem(kSS);
          if(ss){
            const p=JSON.parse(ss);
            if(p && p.items && p.items.length) return p.items;
          }
          const raw = localStorage.getItem(kLS); if(!raw) return null;
          const p = JSON.parse(raw); if(!p || !Array.isArray(p.items)) return null;
          const fresh = (Date.now() - (p.ts || 0)) <= Math.max(1,cfg.cacheMins)*60*1000;
          if(fresh || allowStale) return p.items;
          return null;
        }catch(_e){
          return null;
        }
      }

      // Clean excerpt text; image here is only for safety, not main hero any more.
      function cleanDrupalHtml(raw){
        const html = raw || '';
        const doc = new DOMParser().parseFromString('<div>'+html+'</div>','text/html');
        const root = doc.body.firstElementChild || doc.body;

        ['script','style','noscript','form','nav','header','footer','aside','svg','iframe','source'].forEach(function(sel){
          root.querySelectorAll(sel).forEach(function(el){ el.remove(); });
        });
        ['[class*="breadcrumb"]','[id*="breadcrumb"]','[class*="webform"]','[class*="page__hero"]','[class*="media-oembed"]','[class*="cta-banner"]','[class*="highlighted-links"]']
          .forEach(function(sel){
            root.querySelectorAll(sel).forEach(function(el){ el.remove(); });
          });

        Array.from(root.querySelectorAll('time')).forEach(function(t){
          const parent = t.parentElement;
          const container = parent || t;
          const prev = container.previousElementSibling;
          if(prev && prev.tagName.toLowerCase() === 'span'){
            const txt = (prev.textContent || '').trim();
            if (/^[A-Za-z][\w-]{2,30}$/.test(txt)) prev.remove();
          }
          if (parent && parent.tagName.toLowerCase() === 'span') parent.remove(); else t.remove();
        });

        Array.from(root.querySelectorAll('div,span,strong,em,p,h1,h2,h3,h4,h5,h6')).forEach(function(el){
          const t = (el.textContent || '').trim();
          if (!t) return;
          if (/^(tags?|category)$/i.test(t)) (el.closest('div,section') || el).remove();
          if (/^\d+\s+minute(s)?$/i.test(t)) (el.closest('div,section') || el).remove();
          if (/^Breadcrumb$/i.test(t)) (el.closest('div,nav,section') || el).remove();
        });

        function goodText(txt){
          const t = (txt || '').replace(/\s+/g,' ').trim();
          if (!t) return false;
          if (/^(tags?|category)\b/i.test(t)) return false;
          if (/^posted by|^author:|^by\s/i.test(t)) return false;
          if (/^\d+\s+minute(s)?$/i.test(t)) return false;
          if (/^abrsm$/i.test(t)) return false;
          return t.length >= 48;
        }

        var first = null;
        var prime = root.querySelectorAll('.text-section__text p, .text-section__text .text > p');
        prime.forEach(function(p){
          var t=(p.textContent||'');
          if(!first && goodText(t)){ first=t; }
        });
        if(!first){
          var allp = root.querySelectorAll('p');
          allp.forEach(function(p){
            var t=(p.textContent||'');
            if(!first && goodText(t)){ first=t; }
          });
        }

        var chosen = (first || (root.textContent || '') || '').replace(/\s+/g,' ').trim();

        function dropMetaBits(s){
          var t = s || '';
          t = t.replace(/^(?:Breadcrumb\s+)?Home\s*/i, '');
          t = t.replace(/\bBreadcrumb\s+Home\b/gi, '');
          t = t.replace(/\b[A-Z][A-Za-z0-9_-]{2,}\s+(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s+\d{2}[\/\-]\d{2}[\/\-]\d{4}\s*-\s*\d{2}:\d{2}\b/gi, '');
          t = t.replace(/\b(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s+\d{2}[\/\-]\d{2}[\/\-]\d{4}\s*-\s*\d{2}:\d{2}\b/gi, '');
          return t.replace(/\s{2,}/g,' ').trim();
        }
        chosen = dropMetaBits(chosen);

        var imgEl = root.querySelector('img');
        var foundImg = imgEl && imgEl.getAttribute('src') ? imgEl.getAttribute('src') : extractFirstImg(html);

        return {
          text: chosen,
          excerpt: truncateWords(chosen, cfg.excerptWords),
          image: foundImg || ''
        };
      }

      function parseXMLItems(xmlString){
        const out=[]; if(!xmlString) return out;
        try{
          const doc = new DOMParser().parseFromString(xmlString,'application/xml');
          if(doc.querySelector('parsererror')) throw new Error('xml parse');
          const xmlBase = doc.documentElement.getAttribute('xml:base') || 'https://www.abrsm.org';
          const nodes = doc.querySelectorAll('item,entry');
          nodes.forEach(function(node, idx){
            const titleEl = node.querySelector('title');
            const linkEl = node.querySelector('link[href]') || node.querySelector('link');
            const dateEl = node.querySelector('pubDate,updated,published');
            const encEl  = node.querySelector('content\\:encoded,encoded');
            const descEl = node.querySelector('description,summary');
            const mediaEl = node.querySelector('media\\:content,enclosure');
            const title = titleEl ? (titleEl.textContent || '').trim() : 'ABRSM News';
            let link = '';
            if(linkEl){
              link = (linkEl.getAttribute('href') || linkEl.textContent || '').trim();
            }
            const pub = dateEl ? (dateEl.textContent || '').trim() : '';
            const rawHtml = (encEl ? encEl.textContent : (descEl ? descEl.textContent : '')) || '';
            const decoded = decodeEntities(rawHtml);
            let image = '';
            if(mediaEl){
              image = (mediaEl.getAttribute('url') || '').trim();
            }
            const cleaned = cleanDrupalHtml(decoded);
            const excerpt = cleaned.excerpt;
            if(link){
              out.push({
                id:'ext-' + sectionId + '-rss-'+(idx+1),
                title: title || 'ABRSM News',
                link: resolveUrl(link, xmlBase),
                pubDate: pub ? new Date(pub) : null,
                image: resolveUrl(image, xmlBase),
                excerpt: excerpt
              });
            }
          });
        }catch(_e){}
        return out;
      }

      function parseJSONItems(obj){
        const items=[]; if(!obj) return items;
        if(Array.isArray(obj.items)){
          (obj.items||[]).forEach(function(it,idx){
            const title=(it.title||'ABRSM News').trim();
            const link=it.link||it.url||'';
            const pub=it.pubDate||it.pub_date||it.date||'';
            const html=it.content||it.content_html||it.description||it.excerpt||'';
            const cleaned = cleanDrupalHtml(html||'');
            let image = it.image || it.image_url || it.thumbnail || (it.enclosure && (it.enclosure.link || it.enclosure.url)) || '';
            const excerpt = it.excerpt || cleaned.excerpt || truncateWords(htmlToText(html||''), cfg.excerptWords);
            if(link){
              items.push({
                id:'ext-' + sectionId + '-json-'+(idx+1),
                title:title,
                link:ensureHttps(link),
                pubDate: pub?new Date(pub):null,
                image:ensureHttps(image),
                excerpt:excerpt
              });
            }
          });
          return items;
        }
        if(obj && obj.items && Array.isArray(obj.items)){
          (obj.items||[]).forEach(function(it,idx){
            const title=(it.title||'ABRSM News').trim();
            const link=it.url||it.external_url||'';
            const pub=it.date_published||it.date_modified||'';
            const html=it.content_html||it.summary||'';
            const cleaned = cleanDrupalHtml(html||'');
            let image = '';
            if(Array.isArray(it.attachments)){
              const imgAtt = it.attachments.find(function(a){ return (a.mime_type||'').startsWith('image/'); });
              if(imgAtt) image=imgAtt.url||'';
            }
            const excerpt = cleaned.excerpt || truncateWords(htmlToText(html||''), cfg.excerptWords);
            if(link){
              items.push({
                id:'ext-' + sectionId + '-f2j-'+(idx+1),
                title:title,
                link:ensureHttps(link),
                pubDate: pub?new Date(pub):null,
                image:ensureHttps(image),
                excerpt:excerpt
              });
            }
          });
        }
        return items;
      }

      function buildCard(item, isFirst){
        const el = document.createElement('article');
        el.className='card';
        el.setAttribute('data-remote-item','true');
        const titleId = String(item.id || 'remote-' + sectionId + '').replace(/[^a-zA-Z0-9_-]+/g,'-') + '-title';
        el.setAttribute('aria-labelledby', titleId);

        const a = document.createElement('a');
        a.className='card-link';
        a.href=item.link;
        if(OPEN_TARGET==='_blank'){
          a.target='_blank';
          a.rel=REL_VALUE;
        }

        const media = document.createElement('div');
        media.className='media ratio-' + (list.dataset.imageRatio || 'wide');
        if(item.image){
          const img=document.createElement('img');
          img.src=item.image;
          img.alt='';
          img.decoding='async';
          img.loading='lazy';
          if(cfg.sizes) img.sizes=cfg.sizes;
          media.appendChild(img);
        } else {
          const ph=document.createElement('div');
          ph.className='media-placeholder';
          ph.innerHTML='<span>ABRSM news</span>';
          media.appendChild(ph);
        }
        a.appendChild(media);

        const body = document.createElement('div');
        body.className='body';
        if(SHOW_LABEL){
          const cat=document.createElement('div');
          cat.className='cat';
          cat.textContent = LABEL_TEXT;
          if(SHOW_NEW && item.pubDate instanceof Date){
            const ageDays=Math.floor((Date.now()-item.pubDate.getTime())/86400000);
            if(ageDays<=NEW_DAYS){
              const chip=document.createElement('span');
              chip.className='chip';
              chip.textContent='NEW';
              cat.appendChild(document.createTextNode(' '));
              cat.appendChild(chip);
            }
          }
          body.appendChild(cat);
        }

        const h3=document.createElement('h3');
        h3.className='card-title';
        h3.id = titleId;
        h3.textContent=item.title;
        body.appendChild(h3);

        if(SHOW_EXCERPT && item.excerpt){
          const p=document.createElement('p');
          p.className='excerpt';
          p.textContent=item.excerpt;
          body.appendChild(p);
        }

        const more=document.createElement('span');
        more.className='more';
        more.innerHTML = READ_MORE + '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M13.172 12 8.222 7.05l1.414-1.414L16 12l-6.364 6.364-1.414-1.414z"/></svg>';
        body.appendChild(more);

        a.appendChild(body);
        el.appendChild(a);
        return el;
      }

      function render(items){
        if(destroyed) return;
        setState('render');
        if(!items || !items.length){
          setState('empty');
          toggleEmptyState(true);
          return;
        }
        toggleEmptyState(false);
        items.sort(function(a,b){
          const ta=a.pubDate?+a.pubDate:0;
          const tb=b.pubDate?+b.pubDate:0;
          return tb-ta;
        });
        const take = items.slice(0, Math.max(0, cfg.limit));
        const frag=document.createDocumentFragment();
        take.forEach(function(it,idx){ frag.appendChild(buildCard(it,idx===0)); });
        Array.from(list.querySelectorAll('[data-remote-item="true"], [data-placeholder="true"]')).forEach(function(n){ n.remove(); });
        if(cfg.insert === 'before'){ list.prepend(frag); } else { list.appendChild(frag); }
        setState('done');
      }

      function localShopifyLinks(){
        try{
          return Array.from(list.querySelectorAll('.card .card-link[href^="/"]')).map(function(a){ return a.href.toLowerCase(); });
        }catch(_e){
          return [];
        }
      }

      function hideDupesAgainstLocal(items){
        if(!cfg.hideLocalDupes) return items;
        const locals = new Set(localShopifyLinks());
        return items.filter(function(it){ return !locals.has((it.link||'').toLowerCase()); });
      }

      function containsValidJson(txt){
        try{ const o=JSON.parse(txt); return !!o; }catch(_e){ return false; }
      }

      function buildXmlProxy(feedUrl){
        const f = ensureHttps(feedUrl || DEFAULT_FEED);
        if(!f) return [];
        if(!cfg.allowPublicProxies) return [];

        const codetabs = 'https://api.codetabs.com/v1/proxy?quest='+encodeURIComponent(f);
        const rjina = 'https://r.jina.ai/http://' + f.replace(/^https?:\/\//i,'');

        if(cfg.proxy === 'codetabs') return [codetabs];
        if(cfg.proxy === 'rjina') return [rjina];
        if(cfg.proxy === 'direct') return [f];

        // Avoid browser-side direct RSS and public RSS-to-JSON fallbacks by default.
        // They create CORS/noisy console failures on abrsm.org and are poor pen-test signals.
        return [codetabs, rjina];
      }

      async function fetchFirst(urls, kind){
        for(const u of urls){
          const ac = new AbortController();
          activeFetchControllers.add(ac);
          const timer = setTimeout(function(){
            try{ ac.abort(); }catch(_e){}
          }, Math.max(1200, cfg.timeout));

          try{
            const r = await fetch(u,{signal:ac.signal, credentials:'omit', mode:'cors'});
            if(!r.ok) continue;
            const txt = await r.text();
            if(!txt) continue;
            if(kind==='xml' && containsXmlSignature(txt)) return {ok:true,type:'xml',data:txt};
            if(kind==='json' && containsValidJson(txt)) return {ok:true,type:'json',data:JSON.parse(txt)};
          }catch(_e){
          }finally{
            clearTimeout(timer);
            activeFetchControllers.delete(ac);
          }
        }

        return {ok:false};
      }

      async function fetchFeed(){
        if(cfg.jsonEndpoint){
          try{
            const r=await fetch(cfg.jsonEndpoint,{credentials:'omit',mode:'cors',signal:lifecycleController.signal});
            if(r.ok){
              const j=await r.json();
              return {type:'json', data:j};
            }
          }catch(_e){}
        }
        const xmlTry = await fetchFirst(buildXmlProxy(cfg.feedUrl || DEFAULT_FEED),'xml');
        if(xmlTry && xmlTry.ok) return {type:'xml', data:xmlTry.data};
        return {type:'none', data:null};
      }

      async function fetchArticleHtml(url){
        const link = ensureHttps(url);
        const proxy = cfg.proxy;
        const candidates = [];

        if(!cfg.allowPublicProxies && proxy !== 'direct') return '';

        if(proxy === 'rjina'){
          candidates.push('https://r.jina.ai/http/' + link.replace(/^https?:\/\//i,''));
        }else if(proxy === 'allorigins'){
          candidates.push('https://api.allorigins.win/raw?url='+encodeURIComponent(link));
        }else if(proxy === 'codetabs'){
          candidates.push('https://api.codetabs.com/v1/proxy?quest='+encodeURIComponent(link));
        }else if(proxy === 'direct'){
          candidates.push(link);
        }else{
          // auto
          candidates.push(
            'https://api.codetabs.com/v1/proxy?quest='+encodeURIComponent(link),
            'https://r.jina.ai/http://' + link.replace(/^https?:\/\//i,'')
          );
        }

        for(const u of candidates){
          try{
            const r = await fetch(u,{credentials:'omit',mode:'cors',signal:lifecycleController.signal});
            if(r.ok){
              const t = await r.text();
              if(t) return t;
            }
          }catch(_e){}
        }
        return '';
      }

      // Enrich first N items with featured (og:image) hero image; override any RSS image.
      async function enrichImages(items){
        const count   = Math.min(items.length, Math.max(1, cfg.limit || 3));
        const targets = items.slice(0, count);

        await Promise.all(targets.map(async function(it){
          try{
            const html = await fetchArticleHtml(it.link);
            if(!html) return;
            const found = extractFirstImg(html);
            if(!found) return;
            const resolved = resolveUrl(found, it.link);
            if(resolved){
              it.image = resolved;
            }
          }catch(_e){}
        }));

        return items;
      }

      function immediateSeed(){
        if(!cfg.seed) return null;
        try{
          const obj = JSON.parse(cfg.seed);
          const parsed = Array.isArray(obj) ? { items: obj } : obj;
          let items = parseJSONItems(parsed);
          items = deDupe(items);
          if(items.length){
            render(hideDupesAgainstLocal(items));
          }
          return items;
        }catch(_e){
          return null;
        }
      }

      async function run(forceRefresh){
        setState('loading');
        const seeded = !forceRefresh ? immediateSeed() : null;

        if(seeded && seeded.length && SEED_ONLY){
          return;
        }

        if(seeded && seeded.length && DISABLE_CACHE){
          scheduleWork(async function(){
            const res = await fetchFeed();
            let items = [];
            if(res.type==='xml'){ items=parseXMLItems(res.data);}
            else if(res.type==='json'){ items=parseJSONItems(res.data); }
            items = deDupe(await enrichImages(items));
            if(items.length){
              saveCache(items);
              render(hideDupesAgainstLocal(items));
            }
          });
          return;
        }

        if(!forceRefresh && !DISABLE_CACHE){
          const ss = getCache(true);
          if(ss && ss.length){
            render(hideDupesAgainstLocal(deDupe(ss)));
            const bg = function(){
              fetchFeed().then(async function(res){
                let fresh=[];
                if(res.type==='xml'){ fresh=parseXMLItems(res.data);}
                else if(res.type==='json'){ fresh=parseJSONItems(res.data);}
                fresh = deDupe(await enrichImages(fresh));
                if(fresh.length){
                  saveCache(fresh);
                  render(hideDupesAgainstLocal(fresh));
                }
              });
            };
            scheduleWork(bg);
            return;
          }
          if(seeded && seeded.length){
            scheduleWork(async function(){
              const res = await fetchFeed();
              let items = [];
              if(res.type==='xml'){ items=parseXMLItems(res.data);}
              else if(res.type==='json'){ items=parseJSONItems(res.data); }
              items = deDupe(await enrichImages(items));
              if(items.length){
                saveCache(items);
                render(hideDupesAgainstLocal(items));
              }
            });
            return;
          }
        }

        const res = await fetchFeed();
        let items=[];
        if(res.type==='xml'){ items=parseXMLItems(res.data);}
        else if(res.type==='json'){ items=parseJSONItems(res.data); }
        items = deDupe(await enrichImages(items));
        if(items.length){
          saveCache(items);
        }
        render(hideDupesAgainstLocal(items));
      }

      const refreshBtn = root.querySelector('[data-abrsm-refresh]');
      if(refreshBtn){
        refreshBtn.addEventListener('click', function(){
          try{
            localStorage.removeItem(kLS);
            sessionStorage.removeItem(kSS);
          }catch(_e){}
          run(true);
        }, { signal:lifecycleController.signal });
      }

      function start(){
        if(destroyed) return;
        if(cfg.lazy){
          startObserver = new IntersectionObserver(function(entries){
            for(const e of entries){
              if(e.isIntersecting){
                startObserver.disconnect();
                run(false);
                break;
              }
            }
          }, { rootMargin:'300px 0px' });
          startObserver.observe(root);
        }else{
          run(false);
        }
      }
      start();
  };

  const initAll = (scope = document) => collectRoots(scope).forEach(initBlogPosts);
  const destroyWithin = (scope) => collectRoots(scope).forEach((root) => root.abrsmBlogCleanup?.());
  window.__abrsmBlogPosts = { initAll, destroyWithin };
  initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroyWithin(event.target));
})();
